var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNps = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7282 23.3714L32.4475 22.6528L29.214 15.0394C28.6323 13.6535 26.6476 13.6535 26.0659 15.0394L22.8324 22.6699L14.5688 23.3714C13.0632 23.4911 12.4473 25.3731 13.5936 26.3654L19.8725 31.806L17.9906 39.8814C17.6484 41.3527 19.2395 42.5161 20.5398 41.7291L27.64 37.4519L34.7401 41.7463C36.0404 42.5333 37.6315 41.3699 37.2893 39.8985L35.4074 31.806L41.6863 26.3654C42.8326 25.3731 42.2338 23.4911 40.7282 23.3714ZM27.64 34.2526L21.207 38.1363L22.9179 30.8137L17.2378 25.8864L24.7315 25.2362L27.64 18.3414L30.5656 25.2533L38.0592 25.9035L32.3791 30.8308L34.09 38.1534L27.64 34.2526Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNps);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nps.58116de9a0de559ae988f3eabdad5d00.svg";